import React from "react";
// import PropTypes from "prop-types";
import { Row } from "jsxstyle";
import Table from "components/Table";
import Button from "components/Button";
import Separator from "components/Separator";
import CurrencyFormat from "components/CurrencyFormat";
import DeleteCMBSServicer from "./DeleteCMBSServicer";
import PermissionValidator from "components/PermissionValidator";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";
import PercentFormat from "components/PercentFormat";

function CMBSServicersTable({
  data,
  dealSize,
  pending,
  onReload,
  onRequestEdit,
}) {
  return (
    <PermissionValidator
      allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}
      shouldHide={false}
    >
      {({ isAllowed }) => (
        <Table
          data={data}
          pending={pending}
          rowKey="id"
          columns={[
            {
              title: "Servicer",
              dataIndex: "servicer.long_name",
              key: "servicer.long_name",
            },
            {
              title: "Amount",
              dataIndex: "amount",
              key: "amount",
              render: (amount) => <CurrencyFormat amount={amount} />,
            },
            {
              title: "Amount(%)",
              dataIndex: "amount",
              key: "amount",
              render: (amount) => (
                <PercentFormat
                  amount={(((amount || 0) / dealSize) * 100).toFixed(4)}
                />
              ),
            },
            ...(isAllowed
              ? [
                  {
                    title: "Actions",
                    dataIndex: "",
                    key: "",
                    width: 100,
                    render: (item) => (
                      <Row>
                        <Button
                          icon="edit"
                          onClick={() => onRequestEdit(item)}
                        />
                        <Separator />
                        <DeleteCMBSServicer
                          servicer={item}
                          onDelete={onReload}
                        />
                      </Row>
                    ),
                  },
                ]
              : []),
          ]}
        />
      )}
    </PermissionValidator>
  );
}

CMBSServicersTable.propTypes = {};

CMBSServicersTable.defaultProps = {};

export default CMBSServicersTable;
